<!--
 * @Author: Czy
 * @Date: 2021-12-21 14:08:38
 * @LastEditTime: 2021-12-21 14:08:39
 * @FilePath: /plant-protection-association/src/components/Sidebar.vue
 *  
-->
<template>
  <div class="container">
    <div class="sidebar-box hidden-xs hidden-sm">
      <div class="sidebar-item-one">
        <!-- <router-link to="/plan/anhui">
          <img src="@/assets/img/sidebar/ah1.png" />
        </router-link> -->
        <router-link to="/plan/shanxi">
          <img src="@/assets/img/sidebar/xb.png" />
        </router-link>
      </div>
      <div class="sidebar-item-two">
        <router-link to="/plan/shandong">
          <img src="@/assets/img/sidebar/sd.png" />
        </router-link>
        <router-link to="/plan/heilongjiang">
          <img src="@/assets/img/sidebar/hlj.png" />
        </router-link>
      </div>
      <div class="sidebar-item-three">
        <router-link to="/plan/wholecountry">
          <img src="@/assets/img/sidebar/quangou.png" />
        </router-link>
      </div>
      <div class="sidebar-item-four">
        <img src="@/assets/img/sidebar/follow.png" />
        <div class="applet">
          <img
            src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/xiaochengxu.png"
          />
          <div>云上植保小程序</div>
        </div>
        <div class="official-account">
          <img
            src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/gonzonghao.png"
          />
          <div>云上植保公众号</div>
        </div>
        <div class="video-number">
          <img
            src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/shipinhao.png"
          />
          <div>云上植保视频号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.sidebar-box {
  width: 220px;
  display: flex;
  flex-direction: column;
}
.sidebar-box .sidebar-item-one {
  flex-direction: row;
  display: flex;
}
.sidebar-box .sidebar-item-one img {
  /* width: 20px;
    height: 20px; */
}
.sidebar-box .sidebar-item-two {
  display: flex;
}
.sidebar-box .sidebar-item-three {
}
.sidebar-box .sidebar-item-four {
  width: 219px;
  background-color: #f2f2f2;
  box-shadow: 0 0 12px #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sidebar-box .sidebar-item-four .applet {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}
.sidebar-box .sidebar-item-four .applet img {
  border-radius: 5px;
  margin: 10px 0;
}
.sidebar-box .sidebar-item-four .official-account {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}
.sidebar-box .sidebar-item-four .official-account img {
  border-radius: 5px;
  margin: 10px 0;
}
.sidebar-box .sidebar-item-four .video-number {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}
.sidebar-box .sidebar-item-four .video-number img {
  border-radius: 5px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue